/* eslint-disable no-inline-comments */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Event as UiBaseEvent } from '../../../base/base/index';
import handleAd from './utils/handleAd';
import { getCommentCount, getVideoPlayNum } from './utils/api';
import styles from './index.css';
import SingleTitle from './components/singleTitle';
import Sticky from './components/sticky';
import TitleImg from './components/titleImg';
import BigTopic from './components/bigTopic';
import SlideImg from './components/slideImg';
import BigImg from './components/bigImg';
import TwoImg from './components/twoImg';
import Short from './components/short';
import classNames from './utils/classNames';
// import Quan from './components/quan';
import 'intersection-observer';

const SsrIntersectionObserver = function SsrIntersectionObserver() {};

SsrIntersectionObserver.prototype = {
    observe: function observe() {},
    unobserve: function unobserve() {},
};

const RealIntersectionObserver =
    typeof IntersectionObserver !== 'undefined' ? IntersectionObserver : SsrIntersectionObserver;

class InformationFlow extends PureComponent {
    static propTypes = {
        ad: PropTypes.array, // 信息流内广告
        content: PropTypes.array.isRequired, // 信息流的数据
        preload: PropTypes.bool, // 允许数据的预加载
        preloadContent: PropTypes.array, // 信息流的预加载数据
        isScrollLoadingData: PropTypes.bool, // 是否滚动加载
        handleLoadingDataFunc: PropTypes.func, // 加载更多的函数
        scrollElement: PropTypes.object, // 滚动元素的绑定
        isNoPadding: PropTypes.bool, // 是否显示两侧padding
        isEnd: PropTypes.bool, // 是否已显示全部，true 已显示全部，false 还有数据
        isDisplayLoadingMore: PropTypes.bool, // 是否显示加载更多
        isDisplaySource: PropTypes.bool, // 是否显示新闻来源
        isCount: PropTypes.bool, // 是否显示评论数
        getVideoPlayNum: PropTypes.bool, // 是否显示视频播放数
        isNewsTime: PropTypes.bool, // 是否显示时间
        isFormatTime: PropTypes.bool, // 是否格式化时间
        isLazyImage: PropTypes.bool, // 图片是否懒加载
        insertJSX: PropTypes.string, // 自定义组件
        onItemClick: PropTypes.func, // 信息流自定义点击事件
        moreText: PropTypes.string, //展开更多名称
    };

    static defaultProps = {
        isScrollLoadingData: false,
        scrollElement: typeof window === 'object' ? window : undefined,
        isNoPadding: false,
        isEnd: false,
        isDisplayLoadingMore: true,
        isDisplaySource: true,
        isNewsTime: false,
        isFormatTime: false,
        isCount: true,
        getVideoPlayNum: true,
        isLazyImage: true,
        moreText: '展开更多',
    };

    lastItem = null; // 最后一条数据
    position = null; // 记录滚动的位置
    listRef = React.createRef();
    ind = 0;
    preloadContent = this.props.preloadContent ? this.props.preloadContent : [];
    viewHeight = typeof window === 'object' ? window.innerHeight : null;
    event = new UiBaseEvent();
    scrollLoading = true;

    state = {
        content: this.props.content, // 文章列表
        isEnd: this.props.isEnd, // 是否结束
        isLoading: false, // 是否加载中
        countMapCache: {}, // 缓存评论
        videoPlayCache: {}, // 缓存视频播放量
    };

    async componentDidMount() {
        await this.getCount();
        await this.getVideoCount();

        // 插入广告
        if (this.props.ad && this.props.ad.length > 0) {
            for (const item of this.props.ad) await this.getAd(item);
        }
    }

    observer = new RealIntersectionObserver((changes) => {
        changes
            .filter((item) => item.intersectionRatio > 0)
            .forEach((change) => {
                const { isScrollLoadingData, handleLoadingDataFunc } = this.props;
                const container = change.target;

                const index = container.getAttribute('data-index');
                const ind = Number(index);

                if (
                    isScrollLoadingData &&
                    handleLoadingDataFunc &&
                    this.scrollLoading &&
                    (this.state.content.length - 20 < 0 || ind > this.state.content.length - 20)
                ) {
                    this.handleGetColumnInfoPreloadClick();
                    this.scrollLoading = false;
                }

                if (container.nodeName !== 'IMG') {
                    return;
                }

                container.src = container.getAttribute('data-lazy-src') || container.getAttribute('src');
                container.removeAttribute('data-lazy-src');
                container.classList.add(styles.imageAnimateOpacityZero);

                const handleImageLoadOrError = () => {
                    container.classList.remove(styles.imageAnimateOpacityZero);
                    container.classList.add(styles.imageAnimateOpacityOne);
                    container.removeEventListener('load', handleImageLoadOrError);
                    container.removeEventListener('error', handleImageLoadOrError);
                };

                container.addEventListener('load', handleImageLoadOrError, false);
                container.addEventListener('error', handleImageLoadOrError, false);

                this.observer.unobserve(container);
            });
    });

    // 替换广告数据
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { content } = this.state;

            const infoData = [...content];
            const refs = [];

            insertArr.forEach((value, index, array) => {
                const ref = React.createRef();

                refs.push({ index: value, ref });
                infoData.splice(value, 0, { type: 'ad', ref });
            });

            replaceArr.forEach((value, index, array) => {
                const ref = React.createRef();

                refs.push({ index: value, ref });
                infoData.splice(value, 1, { type: 'ad', ref });
            });

            this.setState(
                {
                    content: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }
    };

    // 获取广告
    async getAd(ad) {
        try {
            const len = this.state.content.length;
            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert);
            this.event.trigger('init', {
                len,
                index: 0,
                scrollElement: this.props.scrollElement,
                listElement: this.listRef.current,
            });
        } catch (err) {
            console.error(err);
        }
    }

    // 加载更多后的获取广告回调
    async getAdAfterLoadMoreCb() {
        const len = this.state.content.length;

        this.event.trigger('loadMoreCmp', {
            len,
            index: 0,
            scrollElement: this.props.scrollElement,
            listElement: this.listRef.current,
        });
    }

    // 获取评论列表
    async getCount() {
        if (!this.props.isCount) {
            return;
        }

        try {
            const { countMapCache, content } = this.state;
            const urlArr = content
                .filter((item) => item.commentUrl && Object.keys(countMapCache).indexOf(item.commentUrl) === -1)
                .map((item) => item.commentUrl);

            const data = urlArr.length > 0 ? await getCommentCount(urlArr) : [];

            data.forEach((value) => {
                countMapCache[value.doc_url] = value.join_count;
            });

            this.setState({ countMapCache: { ...countMapCache } });
        } catch (err) {
            console.error(err);
        }
    }

    // 获取视频播放数
    async getVideoCount() {
        if (!this.props.getVideoPlayNum) {
            return;
        }

        try {
            // 生成评论地址的数组
            const { content, videoPlayCache } = this.state;

            const videoContent = content.filter(
                (item) =>
                    item.type === 'video' || item.type === 'miniVideo' || (item.type === 'short' && item.duration),
            );

            const urlArr = videoContent
                .filter((item) => item.guid && Object.keys(videoPlayCache).indexOf(item.guid) === -1)
                .map((item) => item.guid);

            const data = urlArr.length > 0 ? await getVideoPlayNum(urlArr) : [];

            this.setState({
                videoPlayCache: { ...videoPlayCache, ...data },
            });
        } catch (err) {
            console.error(err);
        }
    }

    // 加载新数据流的评论
    countCallback() {
        this.getCount();
        this.getVideoCount();

        // 加载广告
        if (this.props.ad && this.props.ad.length > 0) {
            for (const item of this.props.ad) this.getAdAfterLoadMoreCb(item);
        }
    }

    // 加载更多
    handleGetColumnInfoClick = async () => {
        const { handleLoadingDataFunc } = this.props;

        if (!handleLoadingDataFunc) return;

        this.setState({ isLoading: true });

        try {
            const data = await handleLoadingDataFunc(this);

            this.setState(
                {
                    content: this.state.content.concat(data.content),
                    isEnd: data.isEnd,
                    isLoading: false,
                },
                () => {
                    this.countCallback();

                    if (data.callback) {
                        data.callback();
                    }
                },
            );
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    };

    // 加载更多的预加载处理
    handleGetColumnInfoPreloadClick = async () => {
        const { handleLoadingDataFunc } = this.props;

        if (!handleLoadingDataFunc) return;

        this.setState({ isLoading: true });

        try {
            const { handleLoadingDataFunc } = this.props;
            const data = await handleLoadingDataFunc(this);

            if (this.isEnd) {
                this.setState(
                    {
                        content: this.state.content.concat(this.preloadContent),
                        isEnd: true,
                        isLoading: false,
                    },
                    () => {
                        this.preloadContent = null;
                        this.countCallback();

                        if (data.callback) {
                            data.callback();
                        }
                    },
                );
            } else {
                this.setState(
                    {
                        content: this.state.content.concat(this.preloadContent),
                        isLoading: false,
                    },
                    () => {
                        this.preloadContent = data.content;
                        this.isEnd = data.isEnd;
                        this.scrollLoading = true;
                        this.countCallback();

                        if (data.callback) {
                            data.callback();
                        }
                    },
                );
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    };

    // 加载更多
    moreView() {
        const { preload, moreText } = this.props;
        const { isEnd, isLoading } = this.state;
        const fn = preload ? this.handleGetColumnInfoPreloadClick : this.handleGetColumnInfoClick;

        let moreView = '';

        if (isEnd) {
            moreView = '已显示全部数据';
        } else {
            moreView = isLoading ? (
                '数据加载中...'
            ) : (
                <a onClick={fn} className={styles.spreadMore}>
                    {moreText}
                    <span className={styles.spreadMoreIcon} />
                </a>
            );
        }

        return moreView;
    }

    // 渲染list
    listView(list) {
        const { countMapCache, videoPlayCache } = this.state;
        const { isDisplaySource, isNewsTime, isFormatTime, isCount, isLazyImage, onItemClick } = this.props;

        return list.map((item, index) => {
            // 渲染广告
            if (item.type === 'ad') {
                return <div className={styles.listItem} key={index} ref={item.ref} />;
            }

            let url = '';

            // 格式化url
            if (item.type === 'topic' || item.type === 'survey' || item.type === 'directSeeding') {
                url = item.wwwUrl;
            } else {
                url = item.url;
            }

            const { commentUrl, guid } = item;
            const query = `docUrl=${commentUrl || guid}&docName=${item.title}&skey=${item.skey}&pcUrl=${item.url}`;
            const pinglunUrl = `https://gentie.ifeng.com/view.html?${query}`;
            const props = {
                index,
                item,
                url,
                pinglunUrl,
                countMapCache,
                videoPlayCache,
                isDisplaySource,
                isNewsTime,
                isFormatTime,
                isCount,
                isLazyImage,
                observer: this.observer,
            };

            const image =
                item.thumbnails && item.thumbnails.image && item.thumbnails.image.length > 0
                    ? item.thumbnails.image
                    : [];

            const key = `${item.id}_${index}`;

            if (item.insertJSX) {
                return <React.Fragment key={key}>{item.insertJSX}</React.Fragment>;
            }

            // 置顶数据
            if (item.stick === 1) {
                return <SingleTitle key={key} {...props} />;
            }

            if (item.stick === 2) {
                return <Sticky key={key} {...props} />;
            }

            // 二图
            if (item.type === 'twoimage') {
                return <TwoImg key={key} {...props} />;
            }

            // 默认左文右图
            let view = <TitleImg key={key} {...props} />;

            // 当无图时默认单标题
            if (!item.thumbnail && image.length === 0) {
                view = <SingleTitle key={key} {...props} />;
            }

            // 专题
            if (item.type === 'topic' || item.type === 'special') {
                if (item.newStyle === 'singletitle' || (!item.thumbnail && image.length === 0)) {
                    view = <SingleTitle key={key} {...props} />;
                } else if (item.newStyle === 'bigtopic') {
                    view = <BigTopic key={key} {...props} />;
                } else if (item.newStyle === 'bigimg' || item.clientStyle === 'bigimg') {
                    view = <BigImg key={key} {...props} />;
                } else {
                    view = <TitleImg key={key} {...props} />;
                }
            }

            // 话题
            if (item.type === 'theme') {
                view = <SingleTitle key={key} {...props} />;
            }

            // 调查
            if (item.type === 'survey') {
                if (
                    item.newStyle === 'singletitle' ||
                    item.newStyle === 'singletext' ||
                    (!item.thumbnail && image.length === 0)
                ) {
                    view = <SingleTitle key={key} {...props} />;
                } else if (item.newStyle === 'slideimg' || item.newStyle === 'ninelattice') {
                    if (image.length > 2) {
                        view = <SlideImg key={key} {...props} />;
                    } else {
                        view = <TitleImg key={key} {...props} />;
                    }
                } else if (
                    item.newStyle === 'bigimg' ||
                    item.newStyle === 'bigimg2' ||
                    item.newStyle === 'titleimgback' ||
                    item.newStyle === 'commitbigimg' ||
                    item.newStyle === 'commitvideobigimg'
                ) {
                    view = <BigImg key={key} {...props} />;
                } else {
                    view = <TitleImg key={key} {...props} />;
                }
            }

            // 文章
            if (item.type === 'article') {
                if (
                    item.newStyle === 'singletitle' ||
                    item.newStyle === 'twsingletitle' ||
                    (!item.thumbnail && image.length === 0)
                ) {
                    view = <SingleTitle key={key} {...props} />;
                } else if (item.newStyle === 'slideimg' || item.newStyle === 'ninelattice') {
                    if (image.length > 2) {
                        view = <SlideImg key={key} {...props} />;
                    } else {
                        view = <TitleImg key={key} {...props} />;
                    }
                } else if (
                    item.newStyle === 'bigimg' ||
                    item.newStyle === 'titleimgback' ||
                    item.newStyle === 'commitbigimg' ||
                    item.newStyle === 'commitvideobigimg' ||
                    item.newStyle === 'twbigimg' ||
                    item.newStyle === 'twvideobigimg'
                ) {
                    view = <BigImg key={key} {...props} />;
                } else {
                    view = <TitleImg key={key} {...props} />;
                }
            }
            // 短内容
            if (item.type === 'shortCustom') {
                view = <Short key={key} {...props} />;
            }
            // 幻灯
            if (item.type === 'slide') {
                if (
                    item.newStyle === 'singletitle' ||
                    item.newStyle === 'titleimg' ||
                    item.newStyle === 'textimg' ||
                    item.newStyle === 'twsingletitle'
                ) {
                    view = <TitleImg key={key} {...props} />;
                } else if (
                    item.newStyle === 'bigimg' ||
                    item.newStyle === 'titleimgback' ||
                    item.newStyle === 'commitbigimg' ||
                    item.newStyle === 'commitvideobigimg' ||
                    item.newStyle === 'twbigimg' ||
                    item.newStyle === 'twvideobigimg'
                ) {
                    view = <BigImg key={key} {...props} />;
                } else if (image.length > 2) {
                    view = <SlideImg key={key} {...props} />;
                } else {
                    view = <TitleImg key={key} {...props} />;
                }
            }

            // 视频
            if (item.type === 'video' || item.type === 'miniVideo') {
                if (
                    item.newStyle === 'singletitle' ||
                    item.newStyle === 'ninelattice' ||
                    item.newStyle === 'titleimg' ||
                    item.newStyle === 'textimg' ||
                    item.newStyle === 'twsingletitle'
                ) {
                    view = <TitleImg key={key} {...props} />;
                } else {
                    view = <BigImg key={key} {...props} />;
                }
            }

            // 直播
            if (item.type === 'directSeeding') {
                view = <BigImg key={key} {...props} />;
            }

            // web 页面
            if (item.type === 'web') {
                if (
                    item.newStyle === 'singletitle' ||
                    item.newStyle === 'twsingletitle' ||
                    (!item.thumbnail && image.length === 0)
                ) {
                    view = <SingleTitle key={key} {...props} />;
                } else if (
                    item.newStyle === 'bigimg' ||
                    item.newStyle === 'titleimgback' ||
                    item.newStyle === 'commitbigimg' ||
                    item.newStyle === 'commitvideobigimg' ||
                    item.newStyle === 'twbigimg' ||
                    item.newStyle === 'twvideobigimg'
                ) {
                    view = <BigImg key={key} {...props} />;
                } else if (item.newStyle === 'slideimg' && image.length > 2) {
                    view = <SlideImg key={key} {...props} />;
                } else {
                    view = <TitleImg key={key} {...props} />;
                }
            }
            // 圈子类型
            if (item.type === 'quan') {
                // view = <Quan key={key} {...props}></Quan>;
                return null;
            }
            return (
                <div
                    key={key}
                    onClick={(e) => {
                        if (onItemClick) {
                            e.preventDefault();
                            onItemClick(item);
                        }
                    }}>
                    {view}
                </div>
            );
        });
    }

    render() {
        const { isDisplayLoadingMore, isNoPadding } = this.props;
        const { content } = this.state;

        return (
            <Fragment>
                <div ref={this.listRef} className={classNames(styles.list, isNoPadding ? styles.noPadding : '')}>
                    {this.listView(content)}
                </div>
                {isDisplayLoadingMore ? <div className={styles.morebox}>{this.moreView()}</div> : null}
            </Fragment>
        );
    }
}

export default InformationFlow;
